import { Box, Button } from '@material-ui/core';
import { Tune } from '@material-ui/icons';
import React, { Dispatch, SetStateAction } from 'react';
import { AnalysisFilterState } from '../../../pages/AnalysisPage/Filter/analysisFilterState';
import { VoxelPopover } from '../../voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../voxel/Popover/VoxelPopoverTrigger';
import HBLtSlider from '../Sliders/HBLtSlider';

export interface AnalysisIntervalsPopoverProps {
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
}

export const AnalysisIntervalsPopover: React.FC<AnalysisIntervalsPopoverProps> = ({
  analysisFilterState,
  setAnalysisFilterState,
}) => {
  return (
    <VoxelPopover enableArrow>
      <VoxelPopoverTrigger>
        <Button size={'small'} startIcon={<Tune />}>
          Intervals
        </Button>
      </VoxelPopoverTrigger>
      <VoxelPopoverContent>
        <Box p={2}>
          <Box>HBLt intervals</Box>
          <Box pr={12}>
            <HBLtSlider
              analysisFilterState={analysisFilterState}
              setAnalysisFilterState={setAnalysisFilterState}
            />
          </Box>
        </Box>
      </VoxelPopoverContent>
    </VoxelPopover>
  );
};
